<template>
  <BtnToggle 
    ref="tool"
    class="tool-text-superscript"
    :class="{ active: selectionFormat.script == 'super' }"
    :title="$t('engine.manageText.modalWidget.tooltip.lblSuperscript', languageEngine)"
    @click="onClick(!value)"
  >
    <IconTextSuperscript/>
  </BtnToggle>
</template>

<script>
import { mapGetters } from "vuex";
import BtnToggle from "./_BtnToggle";
import IconTextSuperscript from "@components_system/Shared/Images/Icon/IconTextSuperscript";

export default {
  components: {
    BtnToggle,
    IconTextSuperscript,
  },
  computed: {
    ...mapGetters({
      languageEngine: "designIframe/userPreference/languageEngine",
      texteditor: "designIframe/texteditor/texteditor",
    }),
    selectionFormat() {
      return this.texteditor.selectionFormat;
    },
    value() {
      if (this.selectionFormat.script == 'sub') return false;
      if (this.selectionFormat.script == 'super') return true;
      return false
    },
  },
  methods: {
    onClick(value) {
      const selection = this.texteditor.editor.getSelection();
      if (value) {
        this.texteditor.editor.formatText({ index: selection.index, length: selection.length }, {
          script: 'super'
        });
      } else {
        this.texteditor.editor.formatText({ index: selection.index, length: selection.length }, {
          script: false
        });
      }
    }
  },
}
</script>
<style lang="scss">
.tool-text-superscript {
  svg {
    margin-top: -3px;
    margin-right: -3px;
  }
  &.active {
    svg {
      path {
        fill: #24BEE2;
      }
    }
  }
}
</style>
